// removed by extract-text-webpack-plugin
module.exports = {"sideBar":"index__sideBar--2oAUE","sideBar--collapsed":"index__sideBar--collapsed--2iyvF","sideBar--scrolling-container":"index__sideBar--scrolling-container--ywZ8m","sideBar-item":"index__sideBar-item--2JcOp","sideBar-item--link":"index__sideBar-item--link--1fed0","sideBar-item--link--collapsed":"index__sideBar-item--link--collapsed--2KAe_","sideBar-item__is-selected":"index__sideBar-item__is-selected--3bloi","has-sidebar-offset":"index__has-sidebar-offset--3IkSp","has-sidebar-offset--collapsed":"index__has-sidebar-offset--collapsed--1at1b","image-container":"index__image-container--3qNgH"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/SideBar/styles/index.scss
// module id = 4Wnq
// module chunks = 23